package com.hyperether.goodjob.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UserTeam(
    @SerialName("id") var id: String? = null,
    @SerialName("value") var value: String? = null,
)